import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Flex, Box } from "@chakra-ui/react";
import { unsetJwtExpired } from "../actions/auth-actions";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';

const JwtExpiredModal = ({ jwtExpired, unsetJwtExpiredState }) => {
  const tokenExpiredMessage = 'You have been signed out. Please log in again to continue.'

  const handleClick = async () => {
    unsetJwtExpiredState()
  }

  return (
      <LaunchdeckModal
          title={'Session expired'}
          noCancelOption={true}
          showModal={!!jwtExpired}
          maxW='35em'
        >
           <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            {tokenExpiredMessage}
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandDark.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={handleClick} label='OK' />
          </Flex>
        </Box>

        </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    jwtExpired: state.auth.data.jwt.isExpired,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    unsetJwtExpiredState: () => dispatch(unsetJwtExpired())
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JwtExpiredModal));